import { SVGProps } from "react";

const CloseIcon = ({
  width = "24",
  height = "24",
  ...props
}: SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    xmlns="http://www.w3.org/2000/svg"
    fillRule="evenodd"
    clipRule="evenodd"
    viewBox={`${(24 - parseFloat(width.toString())) / 2} ${
      (24 - parseFloat(height.toString())) / 2
    } ${width} ${height}`}
  >
    <path d="M12 11.293l10.293-10.293.707.707-10.293 10.293 10.293 10.293-.707.707-10.293-10.293-10.293 10.293-.707-.707 10.293-10.293-10.293-10.293.707-.707 10.293 10.293z" />
  </svg>
);

export default CloseIcon;
